<script lang="ts">
	import { getContext } from 'svelte';
	import { appStore} from '../../stores/appStore';

	const messageId: string = getContext('messageId');
	let animated: boolean;

	$: animated = $appStore.animatedMessageIds.includes(messageId);
</script>

<li class:animated><slot /></li>

<style lang="scss">
	.animated::marker {
		opacity: 0;
		animation: fade 1s linear;
	}

  @keyframes fade {
	  0% {
		  opacity: 0;
	  }
	  50% {
		  opacity: 0.5;
	  }
	  100% {
		  opacity: 1;
	  }
  }
</style>
